import { ISourceType } from 'views/ProFormaTable/types';

/**
 * Check if a source type is a debt source based on its category.
 * @param sourceTypeId - The correlation ID of the source type
 * @param sourceTypes - Array of source types to search
 * @returns true if the source type category is 'debt'
 */
export const isDebtSource = (sourceTypeId: string | undefined, sourceTypes: ISourceType[] | undefined): boolean => {
    if (!sourceTypeId || !sourceTypes) return false;
    const sourceType = sourceTypes.find(st => st.correlationId === sourceTypeId);
    return sourceType?.sourceTypeCategory === 'debt';
};

/**
 * Check if a source type is an equity source based on its category.
 * @param sourceTypeId - The correlation ID of the source type
 * @param sourceTypes - Array of source types to search
 * @returns true if the source type category is 'equity'
 */
export const isEquitySource = (sourceTypeId: string | undefined, sourceTypes: ISourceType[] | undefined): boolean => {
    if (!sourceTypeId || !sourceTypes) return false;
    const sourceType = sourceTypes.find(st => st.correlationId === sourceTypeId);
    return sourceType?.sourceTypeCategory === 'equity';
};

/**
 * Check if a source type is a builder deposit source based on its category.
 * @param sourceTypeId - The correlation ID of the source type
 * @param sourceTypes - Array of source types to search
 * @returns true if the source type category is 'builder_deposit'
 */
export const isBuilderDepositSource = (sourceTypeId: string | undefined, sourceTypes: ISourceType[] | undefined): boolean => {
    if (!sourceTypeId || !sourceTypes) return false;
    const sourceType = sourceTypes.find(st => st.correlationId === sourceTypeId);
    return sourceType?.sourceTypeCategory === 'builder_deposit';
};
